import { Text, Button } from '@/components'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'

interface InitialConnectionViewProps {
  onConfirmClick: () => void
  isLoading: boolean
}

export default function InitialConnectionView({
  onConfirmClick,
  isLoading,
}: InitialConnectionViewProps) {
  return (
    <>
      <Text variant="h2" className="!mt-16">
        Connection Test
      </Text>
      <div className="flex flex-col gap-3 !mt-4">
        <Text variant="body2">
          Click the button below to begin the connection test. The test is very
          quick and will check your Tesla's connection with Optiwatt in just a
          few seconds.
        </Text>
      </div>
      <ButtonContainer>
        <Button
          id="tesla-fleet-auth-survey-continue-button"
          variant="primary"
          disabled={isLoading}
          onClick={onConfirmClick}
        >
          Start Connection Test
        </Button>
      </ButtonContainer>
    </>
  )
}
